export var OperationAction;
(function (OperationAction) {
    OperationAction["Push"] = "Push";
    OperationAction["Transform"] = "Transform";
    OperationAction["CalculateCommitmentPacing"] = "CalculateCommitmentPacing";
    OperationAction["DownloadDocuments"] = "DownloadDocuments";
    OperationAction["UploadDocuments"] = "UploadDocuments";
})(OperationAction || (OperationAction = {}));
